"use client"

import { Localized } from "@/i18n/client"
import Image from "next/image"

import { useSiteMediaUrl } from "@/cms/site-images-client"

export function ScrollToTopButton({ label }: { label: string }) {
  const mediaUrl = useSiteMediaUrl()
  return <Localized>{(
    <button
      type="button"
      className="danaro-footer-scroll danaro-focus-ring"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <Image
        src={mediaUrl("arrowUpIcon")}
        alt=""
        width={24}
        height={24}
        unoptimized
      />
      <span>{label}</span>
    </button>
  )}</Localized>
}
